import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CompanyConfigurationService } from './service/company-configuration.service';

interface CompaniesListModel {
  company_id: string;
  company: string;
  markets: {
    market_subtype?: string[];
    name: string;
  }[];
}

@Component({
  selector: 'app-company-configuration-list',
  templateUrl: './company-configuration-list.component.html',
  styleUrls: ['./company-configuration-list.component.scss']
})

export class CompanyConfigurationListComponent implements OnInit {
  public companiesList: CompaniesListModel[] = [];
  public autocomplete = [];

  constructor(
    private router: Router,
    private companyService: CompanyConfigurationService
  ) {}

  ngOnInit() {
    this.getCompaniesList();
  }

  getCompaniesList(sortItem = { field: 'company.name', type: 'ASC' }, searchField = '') {
    this.companyService.postCompaniesList(sortItem, searchField).subscribe(resp => {
      this.companiesList = [];

      resp.payload.forEach(item => {
        this.companiesList.push({
          company_id: item.company.id,
          company: item.company.name,
          markets: item.markets,
        });
      });
    });
  }

  orderBy(sortItem = { field: '', type: '' }) {
    this.getCompaniesList(sortItem);
  }

  formatMarketName(key: string) {
    switch (key) {
      case 'PRIMARY':
        return 'Primário';
      case 'SECONDARY':
        return 'Secundário';
    }
  }

  formatMarketSub(key: string) {
    switch (key) {
      case 'SALE':
        return 'Venda';
      case 'RENT':
        return 'Locação';
    }
  }

  navigatoToConf(id: string) {
    const navigationExtras = {
      queryParams: { id },
    };

    this.router.navigate(['lista-de-empresas/configuracao-de-empresa'], navigationExtras);
  }

  setElement(event) {
    this.getCompaniesList({ field: 'company.name', type: 'ASC' },  event);
  }

  searchElement(key: string) {
    this.autocomplete = [];

    this.companyService.getCompanyAutoComplete(key).subscribe(resp => {
      resp.forEach(element => {
        this.autocomplete.push({
          type: 'Empresa',
          description: element.original_value,
        });
      });
    });
  }

  getMarketsDescription(markets): string {
    let resp = '';
    if (markets.length === 0) {
      return resp;
    }

    if (markets.length === 2) {
      resp = `${markets[0].name} e ${markets[1].name}`;
    } else {
      resp = `${markets[0].name}`;
    }

    markets.forEach(item => {
      if (item.market_subtype && item.market_subtype.length > 0) {
        resp = `${resp} (${item.market_subtype.join('/')})`;
      }
    });

    return resp;
  }
}
